var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Loader } from '@app/Components/Loader/Loader';
import styles from './grid-loader.module.scss';
var GridLoader = /** @class */ (function (_super) {
    __extends(GridLoader, _super);
    function GridLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridLoader.prototype.render = function () {
        var _a = this.props, loading = _a.loading, className = _a.className;
        if (!loading)
            return null;
        return (React.createElement("div", { className: "".concat(styles.loaderWraper, " ").concat(className) },
            React.createElement("div", { className: styles.panel },
                React.createElement(Loader, { style: { width: 50, height: 50 }, loading: loading }),
                "Loading...")));
    };
    return GridLoader;
}(React.PureComponent));
export { GridLoader };
